import React from "react";
import "./Services.scss";
import withMotion from "../../../Utils/withMotion";

//Pages
import Home from "./Hero/Hero";
import Services from "./Services/Services";

//CTA
import { SpeakWithDesigner } from "../../../CTA/CTA";

//SEO
import SEO from "../../../SEO/index.js";

const ServicesPage = () => {
  return (
    <>
      <SEO
        title="Paver Installation Services | Los Angeles | Pacific Pavingstone"
        description="Whether you're ready for a paving stone driveway, patio, or pool deck, Pacific Pavingstone is the best team in Southern California for you."
        profileURL={"https://www.pacificpavingstone.com/services"}
        type="website"
      />
      <div className="container-fluid page-services">
        <Home />
        <Services />
        <SpeakWithDesigner detailed={true}/>
      </div>
    </>
  );
};

export default withMotion(ServicesPage);
